import { useCompanyStore } from '@/stores/company';
import { Currency } from '@/types';

export const formatCurrency = (value: number, currency?: Currency): string => {
  if (!currency) {
    const { company } = useCompanyStore();
    currency = (company?.currency as Currency) || Currency.Eur;
  }

  const { isUk } = useCompanyStore();
  const locale = isUk ? 'en-GB' : 'nl';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  }).format(value / 100);
};
